import { useEffect, useState } from 'react';
import {
  getSponsors,
  LoadingSponsor,
  OtherSponsor,
  Sponsor,
} from 'api/insurance/sponsors';
import { StandardSelectOption } from 'components/form/Select';

export const useInsuranceOptions = () => {
  const [options, setOptions] = useState<Sponsor[]>([LoadingSponsor]);
  const [sponsors, setSponsors] = useState<Sponsor[]>([]);

  useEffect(() => {
    getSponsors().then(sponsors => {
      sponsors.sort((a, b) => a.displayOrder - b.displayOrder);
      setSponsors(sponsors);
    });
  }, []);

  useEffect(() => {
    if (sponsors.length === 0) return;

    const options = sponsors.slice();
    options.push({
      displayName: 'None',
      id: 'None',
      hidePayerId: false,
      hideGroupId: false,
      displayState: '',
      displayOrder: 1000,
    });

    setOptions(options);
  }, [sponsors]);

  return { options, isLoading: options.length === 1 };
};

export const isOtherSponsor = (sponsors: Sponsor[], name: string) => {
  return (
    name === OtherSponsor.displayName ||
    (!sponsors.find(s => s.displayName === name) && name !== 'None')
  );
};

export const sponsorToSelectOption = (
  sponsor: Sponsor,
): StandardSelectOption => ({
  label: sponsor.displayName,
  value: sponsor.id,
});
